import { render, staticRenderFns } from "./wasiat-details.vue?vue&type=template&id=049075c9&"
import script from "./wasiat-details.vue?vue&type=script&lang=js&"
export * from "./wasiat-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports